import React, { useEffect } from "react";
import { IsRenderable } from "../utils/ServiceManagerAPI";
import { Document, Page } from "react-pdf";
import SkeletonWrapper from "./SkeltonWrapper";
import { PDFDocumentWrapper } from "./RenderAttachments";
import ScrollContainer from "./ScrollContainer";

const RenderFile = ({ file }: { file: File }) => {
    const [pages, setPages] = React.useState(0);
    const [loading, setLoading] = React.useState(true);

    const [fileData, setFileData] = React.useState<string>("");

    useEffect(() => {
        if (file.type != "application/pdf") {
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = (evt: any) => {
                setFileData(evt.target.result);
                setLoading(false);
            };
        }
    }, [file]);

    return (
        <>
            {IsRenderable(file.type) && (
                <div className="p-2">
                    <ScrollContainer direction="-x">
                        {file.type == "application/pdf" && (
                            <PDFDocumentWrapper>
                                <Document
                                    file={file}
                                    onLoadSuccess={({ numPages }: { numPages: number }) => {
                                        setPages(numPages);
                                        setLoading(false);
                                    }}
                                >
                                    {Array.from(new Array(pages), (el, index) => (
                                        <Page pageNumber={index + 1} renderTextLayer={false} renderAnnotationLayer={false} width={750} />
                                    ))}
                                </Document>
                            </PDFDocumentWrapper>
                        )}
                        {file.type != "application/pdf" && (
                            <object
                                style={{ objectFit: "contain", maxWidth: "400px", maxHeight: "400px" }}
                                onLoad={() => setLoading(false)}
                                data={fileData}
                                type={file.type}
                                width="100%"
                                height="100%"
                            ></object>
                        )}
                        <SkeletonWrapper loading={loading}>
                            <></>
                        </SkeletonWrapper>
                    </ScrollContainer>
                </div>
            )}
        </>
    );
};

export default RenderFile;
